import {useAtomValue} from 'jotai';
import {useEffect} from 'react';
import {Awaitable} from 'webapp-lib/typings';

import notificationsAsyncBackend, {
  CommunicationUserSpecificPushNotifications,
} from '@lexian/api/notifications-async-backend';
import {userState} from '_/state/user';

let unsubscribeSocket: (() => void) | null = null;

type Listener = (
  notification: CommunicationUserSpecificPushNotifications
) => Awaitable<void>;

const listeners: Listener[] = [];

function callListeners(
  notification: CommunicationUserSpecificPushNotifications
) {
  if (unsubscribeSocket) {
    listeners.forEach((listener) => {
      listener(notification);
    });
  }
}

export function useEmailPushNotification(listener: Listener): void {
  const user = useAtomValue(userState);

  useEffect(() => {
    if (user && !unsubscribeSocket) {
      const initSocket = () => {
        unsubscribeSocket =
          notificationsAsyncBackend.topicCommunicationUserSpecific(
            {userId: user.userId},
            ({body}) => {
              callListeners(body);
            }
          ).unsubscribe;
      };
      notificationsAsyncBackend.initializeOnConnect(initSocket);
    }

    return () => {
      unsubscribeSocket?.();
    };
  }, [user]);

  useEffect(() => {
    listeners.push(listener);
    return () => {
      listeners.splice(listeners.indexOf(listener), 1);
    };
  }, [listener]);
}
